(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["patikasso-ci-os"]) return;
  try {
    
(function(){
  const root=document.getElementById('PatikassoCustomerIntelligence');
  if(!root)return;
  const token=new URLSearchParams(location.search).get('t')||'';
  const endpoint='https://izzlihdlujzqlnorqmtn.supabase.co/functions/v1/customer-intelligence-data';
  const num=(v,d=0)=>new Intl.NumberFormat('tr-TR',{maximumFractionDigits:d}).format(Number(v||0));
  const money=v=>new Intl.NumberFormat('tr-TR',{style:'currency',currency:'TRY',maximumFractionDigits:0}).format(Number(v||0));
  const set=(s,v)=>{const e=root.querySelector(s);if(e)e.textContent=v};
  const esc=s=>String(s==null?'':s).replace(/[&<>"']/g,m=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[m]));
  function evidenceLine(e){
    if(e.type==='conversion_gap')return 'Bu grupta dönüşüm '+num(e.affected_cvr_pct,2)+'%; karşılaştırma benchmarkı '+num(e.benchmark_cvr_pct,2)+'% ('+num(e.gap_pp,2)+' puan fark).';
    if(e.type==='sample')return num(e.affected)+' yüksek niyetli journey etkilendi; '+num(e.qualified_nonbuyers)+' tanesi satın almadı.';
    if(e.type==='journey_gate')return 'Bu teşhis yalnız normal buyer karar penceresini aşmış yüksek niyetli journeyler için üretildi.';
    if(e.type==='buyer_similarity')return 'Buyer journey benzerliği ortalaması: %'+num(e.avg,1)+'.';
    if(e.type==='recency_intent')return 'Son dönem satın alma niyeti ortalaması: '+num(e.avg,1)+'/100.';
    if(e.type==='overdue_score')return 'Normal karar penceresini aşma skoru: '+num(e.avg,1)+'/100.';
    return Object.entries(e||{}).slice(0,4).map(([k,v])=>k.replaceAll('_',' ')+': '+(Array.isArray(v)?v.join(', '):v)).join(' · ');
  }
  function card(d,i){
    const ev=(d.evidence||[]).slice(0,5).map(x=>'<li>'+esc(evidenceLine(x))+'</li>').join('');
    const alts=(d.alternative_causes||[]).map(x=>'<li>'+esc(x.cause)+' — '+esc(x.status)+'</li>').join('');
    const label=d.confidence_label==='high'?'Yüksek güven':d.confidence_label==='medium'?'Orta güven':'Düşük güven';
    return '<article class="pkci-card">'+
      '<div class="pkci-card__top"><div><span class="pkci-card__rank">'+(i+1)+'</span><h4>'+esc(d.title)+'</h4><p class="pkci-card__summary">'+esc(d.summary)+'</p></div>'+
      '<div class="pkci-card__impact"><span>KARŞILAŞTIRMA HİPOTEZİ</span><strong>Deney gerekli</strong><b>Gözlemsel karşılaştırma · nedensellik kanıtı yok</b></div></div>'+
      '<div class="pkci-card__metrics"><div><span>Bu grupta satın almayan</span><strong>'+num(d.qualified_affected)+'</strong></div><div><span>Mevcut dönüşüm</span><strong>%'+num(d.current_cvr,2)+'</strong></div><div><span>Eşleştirilmiş grup</span><strong>%'+num(d.benchmark_cvr,2)+'</strong></div><div><span>Nedensel etki</span><strong>Henüz doğrulanmadı</strong></div></div>'+
      '<details><summary>Neden böyle diyoruz? Kanıtları göster</summary><div class="pkci-card__detail"><div class="pkci-card__box"><h5>Kanıtlar</h5><ul>'+ev+'</ul></div><div class="pkci-card__box"><h5>Hâlâ elememiz gereken alternatifler</h5><ul>'+alts+'</ul></div><div class="pkci-card__box pkci-card__action"><strong>Ne yapmalıyım?</strong><p>'+esc(d.recommendation?.action||'Kontrollü deney tasarla.')+'</p><p><b>Deney:</b> '+esc(d.experiment_plan?.hypothesis||'Tek değişkenli A/B test.')+'</p></div></div></details>'+
    '</article>';
  }
  async function load(){
    const btn=root.querySelector('[data-ci-refresh]');if(btn)btn.disabled=true;
    try{
      const r=await fetch(endpoint+'?t='+encodeURIComponent(token),{cache:'no-store',credentials:'omit'});
      const d=await r.json();if(!r.ok||!d.ok)throw new Error(d.error||'data');
      const rd=d.readiness||{},sum=d.summary||{},j=d.journey||{};
      const journeyTotal=Number(j.buyer_journeys||0)+Number(j.active_consideration||0)+Number(j.extended_consideration||0)+Number(j.overdue_high_intent||0);
      const journeyScore=Math.round((Math.min(1,Number(j.buyer_journeys||0)/20)*.65+Math.min(1,journeyTotal/100)*.35)*100);
      const journeyReady=d.diagnosis_ready===true;
      set('[data-ci-readiness-score]',num(rd.score||0)+'%');
      const bar=root.querySelector('[data-ci-readiness-bar]');if(bar)bar.style.width=Math.max(0,Math.min(100,Number(rd.score||0)))+'%';
      set('[data-ci-readiness-title]',d.pipeline?.last_attempt_failed?'Son analiz başarısız · sağlam sonuç korunuyor':journeyReady?'Karşılaştırma hipotezleri hazır':'Veri güncel · nedenler henüz doğrulanmadı');
      set('[data-ci-readiness-message]',rd.message||'Veri kalitesi kontrol ediliyor.');
      
      const quality=d.quality||{},orders=d.evidence?.orders||{};
      set('[data-ci-coverage]',num(quality.processed_sessions)+' / '+num(quality.sessions));
      set('[data-ci-coverage-detail]','Kapsam %'+num(quality.coverage_pct,1)+' · '+num(quality.events)+' hareket');
      const dateText=v=>v?new Date(v).toLocaleString('tr-TR',{timeZone:'Europe/Istanbul'}):'—';
      set('[data-ci-freshness]',dateText(d.run?.completed_at));
      set('[data-ci-cutoff]',d.run?.freshness==='stale'?'Veri eski; teşhis kapalı':'Kaynak sınırı: '+dateText(d.evidence?.source_cutoff));
      set('[data-ci-order-quality]',num(orders.paid_exact)+' / '+num(orders.paid)+' kesin');
      set('[data-ci-order-detail]',num(orders.paid_inferred)+' tahmini · '+num(orders.unmatched_paid)+' bağlantısız · '+num(orders.excluded)+' ödeme dışı');
      set('[data-ci-active-quality]',num(quality.active_time_observed_sessions)+' / '+num(quality.sessions));
      const observed=root.querySelector('[data-ci-observed]');
      if(observed)observed.innerHTML=(d.evidence?.categories||[]).map(x=>'<article><span>'+esc(x.category)+'</span><strong>'+num(x.visitors)+'</strong><small>'+num(x.sessions)+' oturum · tekil ziyaretçi</small></article>').join('');
      const segments=root.querySelector('[data-ci-segments]');
      if(segments)segments.innerHTML=(d.evidence?.segments||[]).map(x=>'<tr><td>'+esc(x.source)+'</td><td>'+esc(({mobile:'Mobil',desktop:'Bilgisayar',tablet:'Tablet'})[x.device]||x.device)+'</td><td>'+num(x.sessions)+'</td><td>'+num(x.visitors)+'</td><td>'+num(x.buyer_sessions)+'</td></tr>').join('');
      const roadmap=root.querySelector('[data-ci-roadmap]');
      const stateLabels={data_quality:'Veri kalitesi',observed_issue:'Gözlenen kayıt',hypothesis:'Araştırma hipotezi',insufficient_sample:'Örnek yetersiz'};
      if(roadmap)roadmap.innerHTML=(d.roadmap||[]).map((x,i)=>'<article class="pkci-card"><h4>'+(i+1)+'. '+esc(x.title)+'</h4><small>'+esc(stateLabels[x.status]||x.status)+'</small><p>'+esc(x.action)+'</p><p>'+Object.entries(x.evidence||{}).map(([k,v])=>esc(({exact:'Kesin bağlı',paid:'Ödenmiş',inferred:'Tahmini',processed:'İşlenen',total:'Toplam',sessions:'Oturum',visitors:'Ziyaretçi',buyers:'Satın alan',minimum:'Alt eşik',category:'Kategori'})[k]||k)+': '+esc(v)).join(' · ')+'</p></article>').join('');

      set('[data-ci-buyers]',num(j.buyer_journeys));
      set('[data-ci-considering]',num(Number(j.active_consideration||0)+Number(j.extended_consideration||0)));
      set('[data-ci-overdue]',num(j.overdue_high_intent));
      set('[data-ci-lost]',num(j.likely_lost));
      set('[data-ci-tagged]',sum.total_orders?'%'+num(sum.tagged_order_rate_pct,1):'—');

      const days=j.days_to_purchase||{},sessions=j.sessions_to_purchase||{},arch=j.archetypes||{};
      set('[data-ci-days]',Number(j.buyer_journeys||0)>=20?num(days.median,1)+' gün':'Örnek yetersiz');
      set('[data-ci-days-p90]',Number(j.buyer_journeys||0)>=20?'90% sınırı: '+num(days.p90,1)+' gün':num(j.buyer_journeys)+' satın alan; genelleme yapılmaz');
      set('[data-ci-sessions]',Number(j.buyer_journeys||0)>=20?num(sessions.median,1)+' oturum':'Örnek yetersiz');
      set('[data-ci-sessions-p90]',Number(j.buyer_journeys||0)>=20?'90% sınırı: '+num(sessions.p90,1)+' oturum':'90% sınırı: —');
      const fast=Number(arch.fast_buyer||0),research=Number(arch.research_buyer||0),long=Number(arch.long_decision_buyer||0);
      let archetype='—',detail='Veri toplanıyor';
      if(fast+research+long>=20){
        const pairs=[['Hızlı',fast],['Araştırmacı',research],['Uzun karar',long]].sort((a,b)=>b[1]-a[1]);
        archetype=pairs[0][0];
        detail='Hızlı '+fast+' · Araştırmacı '+research+' · Uzun '+long;
      }
      set('[data-ci-archetype]',archetype);
      set('[data-ci-archetype-detail]',detail);

      const issues=root.querySelector('[data-ci-issues]'),empty=root.querySelector('[data-ci-empty]'),cards=root.querySelector('[data-ci-cards]');
      if((d.diagnostics||[]).length){
        empty.hidden=true;issues.hidden=false;cards.innerHTML=d.diagnostics.map(card).join('');
      }else{
        empty.hidden=false;issues.hidden=true;cards.innerHTML='';
      }

      const dna=root.querySelector('[data-ci-dna]');
      if(dna)dna.innerHTML=(d.buyer_dna||[]).map(x=>{
        let val=num(x.median,1);
        if(String(x.metric).includes('dwell_ms'))val=num(Number(x.median||0)/1000,1)+' sn';
        else if(x.metric==='active_time_s')val=num(x.median,0)+' sn';
        return '<div><span>'+esc(x.label)+'</span><strong>'+val+'</strong></div>';
      }).join('');
    }catch(e){
      set('[data-ci-readiness-title]','Veri servisi kontrol edilmeli');
      set('[data-ci-readiness-message]','Customer Intelligence verisi alınamadı.');
    }finally{if(btn)btn.disabled=false}
  }
  root.querySelector('[data-ci-refresh]')?.addEventListener('click',load);
  load();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["patikasso-conversion-dashboard"]) return;
  try {
    
(function(){
  const root=document.getElementById('PatikassoConversionDashboard');
  if(!root)return;
  const endpoint='https://izzlihdlujzqlnorqmtn.supabase.co/functions/v1/conversion-panel-data';
  const token=new URLSearchParams(location.search).get('t')||'';
  const money=v=>new Intl.NumberFormat('tr-TR',{style:'currency',currency:'TRY',maximumFractionDigits:0}).format(Number(v||0));
  const num=(v,d=0)=>new Intl.NumberFormat('tr-TR',{maximumFractionDigits:d}).format(Number(v||0));
  const set=(sel,val)=>{const el=root.querySelector(sel);if(el)el.textContent=val};
  function funnel(el,rows){
    if(!el)return;
    const max=Math.max(1,...rows.map(x=>Number(x[1]||0)));
    el.innerHTML=rows.map(x=>{
      const v=Number(x[1]||0),w=Math.max(2,Math.round(v/max*100));
      return '<div class="pkdash__funnel-row"><span class="pkdash__funnel-label">'+x[0]+'</span><span class="pkdash__funnel-track"><i class="pkdash__funnel-fill" style="width:'+w+'%"></i></span><b class="pkdash__funnel-value">'+num(v)+'</b></div>';
    }).join('');
  }
  async function load(days){
    root.querySelector('[data-error]').hidden=true;
    set('[data-status] strong','Veri yükleniyor');
    set('[data-status] small','Shopify ve kampanya verileri birleştiriliyor.');
    try{
      const r=await fetch(endpoint+'?days='+days+'&t='+encodeURIComponent(token),{credentials:'omit',cache:'no-store'});
      const d=await r.json();
      if(!r.ok||!d.ok)throw new Error(d.error||'data');
      const h=d.headline||{},status=root.querySelector('[data-status]');
      status.classList.toggle('is-positive',h.status==='Olumlu');
      status.classList.toggle('is-warning',h.status==='Dikkat');
      set('[data-status] strong',h.status||'Veri toplanıyor');
      set('[data-status] small',h.summary||'Veri birikiyor.');
      set('[data-kpi="orders"]',num(h.incremental_orders,1));
      set('[data-kpi="revenue"]',money(h.incremental_revenue));
      set('[data-kpi="lift"]',(Number(h.conversion_lift_pp||0)>=0?'+':'')+num(h.conversion_lift_pp,2)+' puan');
      set('[data-kpi="discount"]',money(h.discount_cost));
      set('[data-kpi="roi"]',h.discount_roi===null?'Veri yok':num(h.discount_roi,2)+'×');
      set('[data-kpi="cannibalized"]',num(h.estimated_cannibalized_orders,1));
      set('[data-detail="treatment-cvr"]',num(h.conversion_rate?.treatment,2)+'%');
      set('[data-detail="control-cvr"]',num(h.conversion_rate?.control,2)+'%');
      set('[data-detail="treatment-sample"]',num(h.visitors?.treatment)+' ziyaretçi · '+num(h.orders?.treatment)+' sipariş');
      set('[data-detail="control-sample"]',num(h.visitors?.control)+' ziyaretçi · '+num(h.orders?.control)+' sipariş');
      set('[data-detail="visitors"]',num(h.visitors?.total));
      ['morph','cart'].forEach(k=>{
        const box=root.querySelector('[data-system="'+k+'"]'),sys=d.systems?.[k]||{},badge=box?.querySelector('[data-system-orders]');
        if(badge)badge.textContent=num(sys.orders||0)+' sipariş';
        funnel(box?.querySelector('[data-funnel]'),sys.funnel||[]);
      });
    }catch(e){
      root.querySelector('[data-error]').hidden=false;
      set('[data-status] strong','Panel açılamadı');
      set('[data-status] small','Güvenli panel bağlantısını kullanın.');
    }
  }
  root.querySelectorAll('[data-days]').forEach(btn=>btn.addEventListener('click',()=>{
    root.querySelectorAll('[data-days]').forEach(x=>x.classList.remove('is-active'));
    btn.classList.add('is-active');
    load(Number(btn.dataset.days||7));
  }));
  load(7);
})();

  } catch(e) { console.error(e); }
})();
})();
